/* eslint-disable camelcase */
import { TOKEN_TYPES } from 'Redesign_Funnel/containers/pages/Validating/constants';
import { AmplitudeNipRequestType } from 'Src/models/Amplitude/NipRequestType';
import { AmplitudeProductType } from 'Src/models/Amplitude/ProductTypes';
import { PaymentType, PaymentChannel } from 'Src/models/Applications/Payment';

export const amplitudeProductTypeByPaymentTypeAndChannel = (
  paymentType: string,
  paymentChannel: string,
  mergedInstore = false,
) => {
  const productType = paymentType?.split('/')[0];

  if (mergedInstore) {
    switch (productType) {
      case PaymentType.Kueskipay:
        return paymentChannel === PaymentChannel.Instore
          ? AmplitudeProductType.INSTORE
          : AmplitudeProductType.ECOMMERCE;
      case PaymentType.InstoreConsumer:
        return AmplitudeProductType.INSTORE;
      case PaymentType.CashInstallments:
        return AmplitudeProductType.INSTALLMENTS;
      default:
        return AmplitudeProductType.UNKNOWN_WILLINGNESS;
    }
  }

  switch (productType) {
    case PaymentType.Kueskipay:
      return paymentChannel === PaymentChannel.Instore
        ? AmplitudeProductType.INSTORE
        : AmplitudeProductType.ECOMMERCE;
    case PaymentType.InstoreConsumer:
      return AmplitudeProductType.INSTORE_CONSUMER;
    case PaymentType.CashInstallments:
      return AmplitudeProductType.INSTALLMENTS;
    default:
      return null;
  }
};

export const amplitudeNipRequestTypeByTokenType = (tokenType: string) => {
  switch (tokenType) {
    case TOKEN_TYPES.CIRCULO_NIP:
      return AmplitudeNipRequestType.CREDIT_HISTORY;
    case TOKEN_TYPES.TOKEN_2FA:
      return AmplitudeNipRequestType.EVALUATION;
    default:
      return null;
  }
};
